import DeleteDiscountContainer from "./DeleteDiscountContainer";
export default DeleteDiscountContainer;
